module.exports = "/_next/static/images/geospital-341a38dc59c5711bd7d6b116eeaddd98.webp";